import React from 'react';
import { 
  Box, 
  Heading, 
  Text, 
  VStack, 
  HStack, 
  Table, 
  Thead, 
  Tbody, 
  Tr, 
  Th, 
  Td, 
  Badge, 
  Card, 
  CardHeader, 
  CardBody, 
  Accordion, 
  AccordionItem, 
  AccordionButton, 
  AccordionPanel, 
  AccordionIcon 
} from '@chakra-ui/react';

const PayerResponsePanel = ({ payerResponse }) => {
  return (
    <Accordion allowToggle mt={4}>
      <AccordionItem border="none">
        <Card borderLeft="4px solid" borderColor="blue.400">
          <CardHeader p={0}>
            <AccordionButton _hover={{ bg: 'blue.50' }} p={4}>
              <Box flex="1" textAlign="left">
                <Heading size="md" color="blue.700">Payer Response (EOB/Denial)</Heading>
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </CardHeader>
          <AccordionPanel pb={4}>
            <CardBody pt={0}>
              {payerResponse ? (
                <VStack align="stretch" spacing={4} mt={2}>
                  <HStack spacing={6}>
                    <Box>
                      <Text fontSize="xs" color="gray.500" textTransform="uppercase">Payer Name</Text>
                      <Text fontWeight="bold">{payerResponse.payer_name || 'Unknown'}</Text>
                    </Box>
                    <Box>
                      <Text fontSize="xs" color="gray.500" textTransform="uppercase">Claim Number</Text>
                      <Text fontWeight="bold">{payerResponse.claim_number || 'Unknown'}</Text>
                    </Box>
                    <Box>
                      <Text fontSize="xs" color="gray.500" textTransform="uppercase">Total Billed</Text>
                      <Text fontWeight="bold">${payerResponse.total_billed?.toFixed(2) || '0.00'}</Text>
                    </Box>
                    <Box>
                      <Text fontSize="xs" color="gray.500" textTransform="uppercase">Total Paid</Text>
                      <Text fontWeight="bold" color={payerResponse.total_paid > 0 ? "green.600" : "red.600"}>
                        ${payerResponse.total_paid?.toFixed(2) || '0.00'}
                      </Text>
                    </Box>
                  </HStack>

                  {payerResponse.line_items && payerResponse.line_items.length > 0 && (
                    <Box mt={2}>
                      <Text fontWeight="bold" mb={2} fontSize="sm">Line Items</Text>
                      <Box overflowX="auto">
                        <Table variant="simple" size="sm">
                          <Thead>
                            <Tr>
                              <Th>CPT</Th>
                              <Th>Mods</Th>
                              <Th isNumeric>Billed</Th>
                              <Th isNumeric>Paid</Th>
                              <Th>CARC</Th>
                              <Th>RARC</Th>
                              <Th>Description</Th>
                              <Th>AI Mapping</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {payerResponse.line_items.map((item, idx) => (
                              <Tr key={idx}>
                                <Td fontWeight="bold">{item.cpt_code}</Td>
                                <Td>{item.modifiers?.join(', ') || '-'}</Td>
                                <Td isNumeric>${item.billed_amount?.toFixed(2) || '0.00'}</Td>
                                <Td isNumeric color={item.paid_amount > 0 ? "green.600" : "red.600"}>
                                  ${item.paid_amount?.toFixed(2) || '0.00'}
                                </Td>
                                <Td><Badge colorScheme="red">{item.carc || '-'}</Badge></Td>
                                <Td><Badge colorScheme="orange">{item.rarc || '-'}</Badge></Td>
                                <Td fontSize="xs" whiteSpace="normal" maxW="300px">{item.description || '-'}</Td>
                                <Td>
                                  <VStack align="start" spacing={1}>
                                    {item.mapped_carcs && item.mapped_carcs.length > 0 ? (
                                      item.mapped_carcs.map((mc, i) => (
                                        <Badge key={i} colorScheme="purple" title={mc.reasoning}>
                                          Mapped CARC: {mc.code} ({(mc.confidence * 100).toFixed(0)}%)
                                        </Badge>
                                      ))
                                    ) : (
                                      <Text fontSize="xs" color="gray.400">-</Text>
                                    )}
                                    {item.dispute_pathway && item.dispute_pathway !== 'standard_appeal' && (
                                      <Badge colorScheme="red">{item.dispute_pathway.toUpperCase()}</Badge>
                                    )}
                                    {item.legal_mandate && (
                                      <Badge colorScheme="blue">{item.legal_mandate}</Badge>
                                    )}
                                  </VStack>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </Box>
                    </Box>
                  )}
                </VStack>
              ) : (
                <Text color="gray.500" fontSize="sm" mt={2}>No payer response data extracted for this case.</Text>
              )}
            </CardBody>
          </AccordionPanel>
        </Card>
      </AccordionItem>
    </Accordion>
  );
};

export default PayerResponsePanel;
